import { getOpenIdEndpoint } from "../openIdAuthCreator/getOpenIdEndpoint";
import { EAuthStrategy } from "../../interfaces/EAuthStrategy";
export const API_PATH_apiAuthMicrosoftOpenIdMethodRedirect = ({ host, companyId, }) => getOpenIdEndpoint({
    host,
    strategy: EAuthStrategy.OAUTH_MICROSOFT,
    endpoint: "client",
    companyId,
});
